<template>
<div class="d-flex justify-content-between">
    <div></div>
    <div class="table-btn-group d-flex align-items-center">

    <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
</div>
</div>
<div class="search-wrap">
        <div class="row">
        <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="기준일">
                <template #end="{id}">
                <div class="d-flex justify-content-between" :id="id">
                    <DatePicker :select-date="state.searchParams.start_dt" @return="r => state.searchParams.start_dt = r" />
                </div>
                </template>
                </ElLabel>
            </div>
        </div>
        <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="회계년도">
                <template #end>
                    <DatePicker v-model="state.searchParams.fiscal_year" :format="state.format" :year-picker="true" @return="r => state.searchParams.fiscal_year = r" :selectDate="state.searchParams.fiscal_year"/>
                </template>
                </ElLabel>
            </div>
        </div>
        </div>
    </div>
    <div class="search-detail-wrap"></div>

<div class="text-end py-2">
    <ElButton type="search" @buttonClick="searchTotalList()">
        검색
    </ElButton>
</div>
<div class="table-responsive table-list">
    <DataTable
        :value="state.totalList"
        paginator :rows="50" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
        scrollable scrollHeight="600px" removableSort
        stripedRows>
        <template #empty>
            <div>데이터가 존재하지 않습니다.</div>
        </template>
        <Column v-for="(opty,index) of state.gridRowColumnTab_1" :key="index" :field="opty.field" 
        :header="opty.header"  :style="opty.style" :sortable="opty.sortable" >
        <template #body="{ data, field}">
            <span v-if="opty.field === 'fcstabc' || opty.field === 'gmamt'">{{ priceToString(data[field])}}</span>
            <div v-else>
                {{ data[field] }}
            </div>
        </template>
        </Column>
    </DataTable>
</div>
<div><ExcelManage
      ref="excelUtilRef"
      v-show="false">
     </ExcelManage>
     </div>
</template>

<script setup>   
import {reactive,ref,onBeforeMount} from 'vue';
import DatePicker     from '@/components/common/DatePicker';
import common         from '@/js/common';
import DataTable      from 'primevue/datatable';
import Column         from 'primevue/column';
import ExcelManage    from '@/components/common/MCO_EX_003.vue'
import { totalList,totalListExcel } from "@/api/batch.js"
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import { useSearchBatchListStore } from "@/store/batchList";
const batchParams = useSearchBatchListStore()

const excelUtilRef = ref()
const yearsList = ref([]);
  // 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
  // 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date();
var startStr = dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
var endStr = dt.getFullYear() + '-' + String(dt.getMonth() + 2).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');

onBeforeMount(async() => {
    if(batchParams.searchParams.fiscal_year){
        state.searchParams.fiscal_year = batchParams.searchParams.fiscal_year;
    }else{
        getYearsList()
    }

    if(batchParams.searchParams.start_dt){
        state.searchParams.start_dt = batchParams.searchParams.start_dt;
    }else{
        state.searchParams.start_dt = startStr;
        state.searchParams.end_dt = endStr;
    }
    await searchTotalList();

});

const state = reactive({
    gridRowColumnTab_1:[
        { header: "기준일", field: "start_dt", style: { minWidth: '50px' ,maxWidth: '50px',fontSize: '12px'},sortable:false},
        { header: "상품", field: "prod_nm", style: { minWidth: '80px' ,maxWidth: '90px',fontSize: '12px'},sortable:false},
        { header: "FCST ABC", field: "fcstabc", style: { textAlign: 'right', minWidth: '100px' ,maxWidth: '150px',fontSize: '12px'},sortable:true},
        { header: "GM Amount", field: "gmamt", style: { textAlign: 'right',minWidth: '100px' ,maxWidth: '150px',fontSize: '12px'},sortable:true},
    ],
    excelCol : [
        { header: "No.", field: "index"},
        { header: "회계년도", field: "fiscal_year"},
        { header: "기준일", field: "start_dt"},
        { header: "상품", field: "prod_nm"},
        { header: "FCST ABC", field: "fcstabc"},
        { header: "GM Amount", field: "gmamt"},
    ],
    searchParams : {
        start_dt : '',
        fiscal_year:'',
        employee_id : userStore.user.employeeId,
        auth_grp_id : userStore.user.authGrpId
    },
    totalList :[],
    yearsList: [],
    format:'yyyy'
});


function getYearsList() {
  const prevYear = new Date().getFullYear() - 3;   
  const currYear = new Date().getFullYear();    
  for (let i = currYear; i >= prevYear; i--) {
    yearsList.value = [...yearsList.value, i];  
  }
  state.searchParams.fiscal_year = yearsList.value[0];

}

const priceToString = (item) => {
    return common.checkNumberComma(item)
}

//엑셀 다운로드
const excelDown = async () =>{
    let fileNm = '전체합계 배치 결과 조회 ' + '_' + state.searchParams.fiscal_year + ' ' +state.searchParams.start_dt 
    let header = [...state.excelCol];
    try{
        setIsLoading(true)
        const res = await totalListExcel(state.searchParams)
        let dataList = [...res.rtn].map((item,index)=>{
            item.index = (index+1)
            Object.keys(item).forEach((key)=>{
            if(key === 'fcstabc' || key === 'gmamt'){
                item[key] = isNaN(Number(item[key])) ? item[key] : Number(item[key])
            }
        })
        return item
    })
        excelUtilRef.value.excelDownload(fileNm, header, dataList);
    }catch(e){
        console.log(e)
    }finally{
        setIsLoading(false)
    }
}

const searchTotalList = async () => {
try {
    setIsLoading(true)
    batchParams.searchParamsData(state.searchParams)
    const res = await totalList(state.searchParams)
    state.totalList = res.rtn
    } catch (err) {
        console.error(err)
    } finally {
        setIsLoading(false)
    }   
};
</script>
